module.exports = __webpack_public_path__ + "static/media/desktop-page-cover-layer-1.e4ceacb9.jpg";